"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
var Orientation;
(function (Orientation) {
    Orientation[Orientation["Horizontal"] = 0] = "Horizontal";
    Orientation[Orientation["Vertical"] = 1] = "Vertical";
})(Orientation = exports.Orientation || (exports.Orientation = {}));
exports.useStyle = styles_1.makeStyles({
    formControl: {
        marginTop: "20px",
        fontSize: "0.875rem"
    },
});
function SelectKTR(props) {
    const classes = exports.useStyle();
    const theme = styles_1.useTheme();
    return (react_1.default.createElement(core_1.FormControl, { className: classes.formControl, component: "fieldset" },
        react_1.default.createElement(core_1.FormLabel, { component: "legend", style: theme ? { color: theme.palette.text.primary } : null },
            " ",
            props.title,
            "  "),
        react_1.default.createElement(core_1.RadioGroup, { onChange: e => props.onChange(e.target.value), row: props.orientation === Orientation.Horizontal ? true : false }, props.menuItems ?
            props.menuItems.map((val, index) => {
                return (react_1.default.createElement(core_1.FormControlLabel, { key: index, value: props.getOptionValue(val), control: react_1.default.createElement(core_1.Radio, { checked: props.elementIsChecked(val) }), label: props.getOptionLabel(val) }));
            }) : ""),
        props.error ?
            react_1.default.createElement(core_1.Typography, { style: { fontSize: "0.8rem", color: theme ? theme.palette.error.main : null } }, props.errorText)
            : ""));
}
exports.default = SelectKTR;
//# sourceMappingURL=Selection.js.map